import Typography from "@material-ui/core/Typography/Typography";
import Link from "@material-ui/core/Link/Link";
import React from "react";
import {defaultVariabls} from "../../../config/index";
import {Translate} from "../../../config/Translate";
import moment from "jalali-moment";
import {getStore} from "trim-redux";

export default function Copyright(props) {
    const app_name = getStore('app_name');
    return (
        <Typography className={props.className} variant="body2" color={props.light ? "secondary" : "textSecondary" } align="center">
            {Translate.copyright}
            <Link color="inherit" href={defaultVariabls.React}>
                {app_name}
            </Link>{' '}
            {moment().locale('fa').format('YYYY')}
        </Typography>
    );
}